import { Button } from "@mui/material";
import React, { Component, Fragment } from "react";
import postService from "../services/postService";
import Logo from "./commons/Logo";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import SimpleBar from "simplebar-react";
import formatDistance from "date-fns/formatDistance";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import CircularProgress from "@mui/material/CircularProgress";

const now = new Date();

function getPostDate(creationDate) {
  return formatDistance(new Date(creationDate), now, {
    addSuffix: true,
  });
}

class Embed extends Component {
  state = {
    loadedPost: false,
    post: {},
    postExists: true,
  };

  componentDidMount = async () => {
    await this.loadPost();
  };

  loadPost = async () => {
    const { id } = this.props.match.params;
    try {
      const response = await postService.getPost(id);
      const post = response.data.data;
      this.setState({
        loadedPost: true,
        post,
      });
    } catch (error) {
      if (error.response) {
        if (error.response.status == 404) {
          this.setState({
            postExists: false,
          });
        }
      }
    }
  };

  render() {
    const appUrl = process.env.REACT_APP_URL;
    const { loadedPost, post, postExists } = this.state;

    if (!postExists) {
      return (
        <div
          style={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              textAlign: "center",
              fontSize: 20,
            }}
          >
            <Logo style={{ fontSize: 30 }} />
            <p style={{ marginTop: 5 }}>Post not found</p>
          </div>
        </div>
      );
    }

    if (!loadedPost) {
      return (
        <div
          style={{
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div style={{
            textAlign: 'center'
          }}>
            <Logo
              style={{
                fontSize: 30,
                marginBottom: 20
              }}
            />
            <CircularProgress thickness={5} size={30}/>
          </div>
        </div>
      );
    }

    return (
      <Fragment>
        <SimpleBar style={{ maxHeight: "100%" }} autoHide={false}>
          <div
            className="post nohover"
            style={{
              display: "flex",
              borderBottom: 0,
              cursor: "auto",
              position: "relative",
            }}
          >
            <a
              href="/"
              target="_blank"
              style={{
                position: "absolute",
                top: 10,
                right: 30,
                color: "initial",
                textDecoration: "none",
              }}
            >
              <Logo
                style={{
                  fontSize: 18,
                }}
              />
            </a>
            <div className="post-profile-pic">
              <div className="pic-container">
                <img
                  src={`${process.env.REACT_APP_BACKEND_API_PATH}/profile/${post.author.username}/pic`}
                />
              </div>
            </div>
            <div className="post-data">
              <div className="post-metadata">
                <a
                  href={`/profile/${post.author.username}`}
                  target="_blank"
                  style={{
                    color: "initial",
                    textDecoration: "none",
                  }}
                >
                  <div className="post-author">{post.author.username}</div>
                </a>
                <div className="post-date">{getPostDate(post.createDate)}</div>
              </div>
              <div className="post-content">
                <h3 className="heading post-heading">{post.title}</h3>
                <p className="post-body">{post.body}</p>
              </div>
              <div className="post-actions">
                <div className="post-action">
                  <ChatBubbleOutlineIcon className="icon" />
                  {post.numOfReplies}
                </div>
              </div>
            </div>
          </div>
          <a
            target="_blank"
            href={`${appUrl}/post/${post.id}`}
            style={{
              color: "initial",
              textDecoration: "none",
              display: "block",
              textAlign: "center",
            }}
          >
            <Button
              variant="outlined"
              style={{
                width: "90%",
                fontFamily: "inherit",
                color: "var(--theme-orange)",
                borderColor: "var(--theme-orange)",
                marginBottom: 10,
              }}
              endIcon={<RocketLaunchIcon />}
            >
              View on OuMedia
            </Button>
          </a>
        </SimpleBar>
      </Fragment>
    );
  }
}

export default Embed;
